import { useEffect } from "react";

import { useABTestingGAUserProperties } from "./use-ab-testing-ga-user-properties";
import { useABTestingSWR } from "./use-ab-testing-swr";

export function useABTestingEffect(): void {
  const { data } = useABTestingSWR();
  const { updateMatrix: updateGAMatrix } = useABTestingGAUserProperties();

  useEffect(() => {
    if (data === undefined) return;
    updateGAMatrix?.(data);
  }, [data, updateGAMatrix]);
}
